<template>
  <el-dialog
    :visible.sync="visible"
    v-if="visible"
    width="40%"
    center
    class="Dialog"
    title="应付结算费用对账"
  >
    <div class="dialog-content">
      <div style="display: flex; justify-content: space-around">
        <div
          ><div>选择对账模板</div>
          <span style="display: inline-block; width: 80%; height: 2px; background: #ccc"></span
        ></div>
        <div
          @click="downExcelTemplate('092')"
          style="
            width: 20%;
            text-align: center;
            line-height: 42px;
            background: #f8f7ff;
            cursor: pointer;
          "
          class="btnHandler"
          >下载模版</div
        >
      </div>
      <div style="display: flex; justify-content: space-around; margin-top: 30px">
        <div
          ><div>上传对账模板</div
          ><span style="display: inline-block; width: 80%; height: 2px; background: #ccc"></span
        ></div>
        <div
          @click="importBtnClickHandler"
          style="
            width: 20%;
            text-align: center;
            line-height: 42px;
            background: #f8f7ff;
            cursor: pointer;
          "
          class="btnHandler"
          >数据上传</div
        >
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <!-- <el-button type="primary" style="margin-top: 15px" @click="visible = false">取消</el-button> -->
        <el-button type="primary" style="margin-top: 15px" @click="deductionHandler"
          >开始对账</el-button
        >
      </span>
    </template>
    <el-upload
      style="display: none"
      ref="siruiUpload"
      :data="importData"
      :action="uploadUrl"
      accept=".xls,.xlsx"
      :before-upload="uploadBefore"
      :on-success="uploadSuccess"
      :show-file-list="false"
      :with-credentials="true"
      :on-error="uploadError"
    >
      <el-button ref="importBtn"></el-button>
    </el-upload>
  </el-dialog>
</template>

<script>
  import { searchColumns, defaultTableColumn } from './index.js';
  // , tableList
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  import baseUrl from '@/common/config';
  export default {
    props: {},
    data() {
      return {
        load: false,
        menuButtonList: [], // 表格功能按钮
        selectionList: [], // 表格被选中的行数据
        tableData: [], // 表格数据
        columnList: defaultTableColumn,
        query: {
          payeeNo: '',
          purchaseOrderNoStr: '',
          paymentApplyNumber: '',
          payeeName: '',
        },
        visible: false,
        deductAllPrice: null,
        outerOriginalTotalAmount: null, //基本信息中原币结算金额
        serviceTypeList: [],
        uploadUrl: '',
        importData: {}, // 导入参数
        excelData: [],
      };
    },
    computed: {
      searchFormColumns() {
        return searchColumns(this);
      },
    },
    mounted() {},
    methods: {
      // 导入
      importBtnClickHandler() {
        this.$refs.importBtn.$el.click();
        this.setImport();
      },
      // 设置导入配置
      setImport() {
        this.uploadUrl = baseUrl + '/' + RECEIVABLES_MULTIMODALTRANSPORT.IMPORT_PAYBLES_EXCEL_API;

        this.importData = {
          access_token: this.userInfo.access_token,
        };
      },
      // 开始上传
      uploadBefore(file) {
        console.log(file, '上传文件9999999999');
        this.excelData = [];
        if (['xlsx', 'xls'].includes(file.name.split('.')[1])) {
          this.loading.startLoading();
        } else {
          // this.$message.error('请上传正确的附件');
          this.loading.endLoading();
          return;
        }
      },
      // 上传成功
      uploadSuccess(response) {
        this.loading.endLoading();
        if (response.code === 0) {
          console.log(response.data, 'response.data');
          if (response.data.length < 1) {
            this.$message.error('不支持的文件内容');
            return;
          }
          this.$message.success('导入成功');
          this.excelData = response.data;
        } else {
          this.$message.error(`${response.msg}`);
        }
      },
      // 上传错误
      uploadError() {
        this.loading.endLoading();
        this.$message({
          showClose: true,
          message: this.$t('bank.message.importError'),
          type: 'error',
        });
      },

      openDialog() {
        this.visible = true;
      },

      //确认
      async deductionHandler() {
        if (this.excelData.length < 1) {
          this.$message.error('请上传数据');
          return;
        }
        this.loading.startLoading();
        const postData = {
          trackingList: this.excelData,
          expenseNoList: this.serviceTypeList,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.PAYBLES_CHECK_API,
          postData
        );
        console.log(data, '对比结果');

        if (data.code == 0) {
          this.loading.endLoading();
          this.excelData = [];
          if (data.data) {
            // window.open(data.data, '_blank');
            this.visible = false;
            this.$message.error('对账失败');
            setTimeout(() => {
              window.location.href = data.data;
            }, 50);
          } else {
            this.visible = false;
            this.$message.success(`${data.msg}`);
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    padding-bottom: 5px;
    box-sizing: border-box;
    .title {
      width: 100%;
      font-size: 25px;
      padding: 10px;
      border-bottom: 2px solid #ddd;
      margin-bottom: 10px;
      box-sizing: border-box;
    }
  }
  ::v-deep {
    .el-dialog__body {
      padding: 15px 20px !important;
    }
    .vxe-toolbar {
      display: none;
    }
    .vxe-grid {
      margin-top: 60px;
    }
  }

  .btnHandler:hover {
    background: #323484 !important;
    color: white;
  }
</style>
